import React from 'react';
import SolutionSealCompleteContainer from 'containers/SolutionSealCompleteContainer';

export default function SolutionSealCompletePage() {
  return (
    <SolutionSealCompleteContainer />
  )
}
